import api from './api';

class NotificationService {
  // Get all notifications
  async getNotifications() {
    try {
      const response = await api.get('/notifications');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Mark notification as read
  async markAsRead(notificationId) {
    try {
      const response = await api.put(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      const response = await api.put('/notifications/read-all');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Delete a notification
  async deleteNotification(notificationId) {
    try {
      const response = await api.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Get unread notifications count
  async getUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Subscribe to push notifications
  async subscribeToPushNotifications(subscription) {
    try {
      const response = await api.post('/notifications/subscribe', { subscription });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Unsubscribe from push notifications
  async unsubscribeFromPushNotifications(subscription) {
    try {
      const response = await api.post('/notifications/unsubscribe', { subscription });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Send a new notification
  async sendNotification(notificationData) {
    try {
      const response = await api.post('/notifications/send', notificationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new NotificationService(); 